export default __webpack_public_path__ + "static/media/EI2-1.5e2fd796.jpg";